//@flow
import { data } from "cockpit-shared";
import * as constants from "../constants";

export function getLocalizedNumberFormatter(): Object {
  let localeId = constants.Device.Locale;
  return new data.number.NumeralNumberFormattingService("de-ch");
}